var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-course-notes studyNotes" },
    [
      _c("div", { staticClass: "video-header" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "span",
            {
              staticClass: "title",
              on: {
                click: function ($event) {
                  return _vm.isShowFace(5)
                },
              },
            },
            [_vm._v(_vm._s(_vm.courseDatas.title))]
          ),
        ]),
        _c("div", { staticClass: "right" }, [
          _c(
            "span",
            {
              staticClass: "opera fr",
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _c("i", { staticClass: "iconfont iconfanhuijiantou" }),
              _vm._v(" 返回 "),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "video-wrap" }, [
        _c(
          "div",
          { staticClass: "video-box", attrs: { id: "uniVideoPlayer" } },
          [
            _c("TencenVideo", {
              ref: "tenCenVideo",
              attrs: {
                videoData: _vm.videoData,
                lessonsUuid: _vm.lessonsUuid,
                sectionDatas: _vm.sectionDatas,
              },
              on: {
                lessonChangeNext: _vm.lessonNext,
                isShowFace: _vm.isShowFace,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "notes-box", class: _vm.isNoteVisible ? "hide" : "" },
          [
            _c("Notes", {
              attrs: {
                lessonsUuid: _vm.lessonsUuid,
                courseDatas: _vm.sectionDatas,
                teacherDatas: _vm.teacherData,
              },
              on: { change: _vm.lessonChange },
            }),
          ],
          1
        ),
      ]),
      _vm.isFaceVideo
        ? _c("FaceVideo", {
            on: { isRouter: _vm.isRouter, isFailure: _vm.isFailure },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }